export default __webpack_public_path__ + "static/media/icon-brand-association.2fa76f0c.svg";